import ReducerUtils from "../../utils/ReducerUtils"
import Actions from "../../model/constant/actions"

const LatestCopyId = ReducerUtils.createReducer<number>(null,{
  [Actions.SET_MARKETING_EVENT_LATEST_COPY_ID] : (_state, action) => action.id 
})

export default LatestCopyId
